export enum DashboardTypes {
  SET_DASHBOARD = 'SET_DASHBOARD',
  SET_BALANCE_PER_COIN = 'SET_BALANCE_PER_COIN',
  SET_VOLUME_OF_OPERATIONS='SET_VOLUME_OF_OPERATIONS',
  SET_VOLUME_OF_OPERATIONS_PER_COIN='SET_VOLUME_OF_OPERATIONS_PER_COIN',
  SET_LOADING = 'SET_LOADING',
  LOGOUT = 'LOGOUT'
}